import React from 'react';

import emptyImg from '../../assets/il-no-visuals-yet.png';
import emptyImg2x from '../../assets/il-no-visuals-yet@2x.png';
import {flashFocus} from '../../util/flash';
import EmptyWatermark from '../EmptyWatermark';

// This message appears if the section has panels, but no data for those panels
// i.e. 0 active panels and >0 inactive panels
export const EmptySectionMessageNoMetrics = () => (
  <EmptySectionMessageGeneric
    header="No metrics logged yet."
    details={<div>Charts will appear here as data is logged.</div>}
  />
);

// This message appears if the section has no panels at all
// i.e. 0 active panels and 0 inactive panels
export const EmptySectionMessageNoPanels = () => {
  return (
    <EmptySectionMessageGeneric
      header="No panels in this section."
      details={
        <div style={{display: 'flex', alignItems: 'center'}}>
          <div style={{marginRight: 4}}>
            <span className="hide-in-report">Drag a panel here, or </span>
            <span
              className="add-vis-helper underline-dashed"
              onClick={(e: React.MouseEvent) => {
                const el = (
                  e.currentTarget.closest('.panel-bank__section') ||
                  e.currentTarget.closest('.report-section')
                )?.querySelector('.add-vis-button');
                if (el) {
                  flashFocus(el, {
                    minSpaceFromTop: 60,
                    padding: 3,
                    popping: true,
                  });
                }
              }}>
              add a visualization
            </span>
            .
          </div>
        </div>
      }
    />
  );
};

// This is a generic message template that appears when there are no visible panels in a section.
// Customize it by passing in a header and details.
const EmptySectionMessageGeneric = ({
  header = 'No panels yet.',
  details = "Add panels to illustrate the runs from this section's data.",
}: {
  header?: string;
  details?: string | JSX.Element;
}) => {
  return (
    <EmptyWatermark
      className="empty-watermark-visualizations"
      imageSource={emptyImg}
      imageSource2x={emptyImg2x}
      header={header}
      details={details}
      wide
    />
  );
};
